import { JWTUserData } from '@kit/supabase/types';
import { Header } from '@kit/ui/marketing';

import { AppLogo } from '~/components/app-logo';

import { SiteHeaderAccountSection } from './site-header-account-section';
import { SiteNavigation } from './site-navigation';

/**
 * The marketing header wears the same mark as the app.
 *
 * It used to draw its own lockup (a lucide `Boxes` glyph in a dark tile) while
 * onboarding and the signed-in app used `AppLogo`, so the brand changed shape
 * the moment someone signed up. Do not reintroduce a marketing-only logo here:
 * `AppLogo` is the one mark, and changing it there changes it everywhere.
 */
export function SiteHeader(props: { user?: JWTUserData | null }) {
  return (
    <Header
      /*
       * The bar takes the card surface, not the page surface. On
       * `bg-background` it was the exact lavender of the page scrolling
       * underneath it, so the only thing separating the two was an 11%-alpha
       * hairline and the site read as one continuous field from the nav down
       * to the footer. White over lavender is a step nobody has to look for,
       * and the shadow keeps the bar reading as the thing on top once content
       * starts passing beneath it.
       */
      className="border-border bg-card/85 z-50 border-b shadow-[0_1px_2px_rgba(22,22,42,0.04),0_10px_28px_-22px_rgba(22,22,42,0.45)] backdrop-blur-xl"
      logo={<AppLogo />}
      navigation={<SiteNavigation />}
      actions={<SiteHeaderAccountSection user={props.user ?? null} />}
    />
  );
}
